import "../style/thumbnail.css";

export default function Thumbnail({ video, selectedIndex, index, handleClick }) {
    return (
        <div className={"thumbnail" + ((index === selectedIndex) ? "" : " unselected")}>
            <img
                src={`../assets/pictures/thumbnails/${video.thumbnailName}`}
                alt={`${video.name} thumbnail`}
                onClick={handleClick}
            />
            <div>
                {video.name}
            </div>
        </div>
    )
}
